import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { useSelector } from "react-redux";

import Gallery from "../Common/Gallery";

import { ileggelsestyper } from "../../constants/globals";
import { bypatruljen, juridisk } from "../../constants/roles";
import { authorized } from "../../utils/authorizationUtils";

const isAuthorizedForRediger = () =>
  authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    juridisk.saksbehandler,
  ]);

const getBildeUrl = (bildeId, ileggelseId, ileggelsestypeId) => {
  return ileggelsestypeId === ileggelsestyper.miljogebyr
    ? `klage/miljogebyrer/${ileggelseId}/bilder/${bildeId}`
    : `klage/ileggelser/${ileggelseId}/bilder/${bildeId}`;
};

const getRedigerUrl = (bildeId, ileggelseId, ileggelsestypeId) => {
  return `${getBildeUrl(bildeId, ileggelseId, ileggelsestypeId)}/rediger`;
};

const BilderContainer = ({ isThumbAndLightboxImg }) => {
  const ileggelseId = useSelector(
    (state) => state.klageIleggelse && state.klageIleggelse.id
  );
  const ileggelsestypeId = useSelector(
    (state) => state.klageIleggelse && state.klageIleggelse.ileggelsestypeId
  );
  const thumbnailImages = useSelector((state) =>
    isThumbAndLightboxImg
      ? state.klageIleggelseThumbnailImage
      : state.klageIleggelseImage
  );
  const lightboxImages = useSelector(
    (state) => state.klageIleggelseLightboxImage
  );
  const getRedigerUrlHandler = useCallback(
    (bildeId) => getRedigerUrl(bildeId, ileggelseId, ileggelsestypeId),
    [ileggelseId, ileggelsestypeId]
  );
  const getBildeUrlHandler = useCallback(
    (bildeId) => getBildeUrl(bildeId, ileggelseId, ileggelsestypeId),
    [ileggelseId, ileggelsestypeId]
  );

  if (isEmpty(thumbnailImages)) return null;
  return (
    <section className="detalj-ileggelse-section-margin">
      <div style={{ marginTop: 10 }}>
        <Gallery
          images={thumbnailImages}
          lightboxImages={lightboxImages}
          isAuthorizedForRediger={isAuthorizedForRediger()}
          getRedigerUrl={getRedigerUrlHandler}
          getBildeUrl={getBildeUrlHandler}
        />
      </div>
    </section>
  );
};

BilderContainer.propTypes = {
  isThumbAndLightboxImg: PropTypes.bool.isRequired,
};

export default BilderContainer;
